import { dateFormat } from "@/utils/dateFormat.js";
var OSS = require("ali-oss");

export default {
  /**
   * 创建随机字符串
   * @param num
   * @returns {string}
   */
  randomString(num) {
    let chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ];
    let res = "";
    for (let i = 0; i < num; i++) {
      var id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },

  /**
   * 创建oss客户端对象
   * @returns {*}
   */
  createOssClient() {
    return new Promise(resolve => {
      let client = new OSS({
        region: "oss-cn-shanghai",
        accessKeyId: "LTAI5tFTFrGh89cCFhUpfLdb",
        accessKeySecret: "U7XR6YpBzbicLgk7O7kOFgatAS6WKa",
        bucket: "eye-lib"
      });
      resolve(client);
    });
  },

  // 图片上传
  ossUploadImg(option) {
    let file = option.file;
    const self = this;
    return new Promise((resolve, reject) => {
      let date = dateFormat(new Date(), "yyyyMMdd"); // 当前时间
      let randomStr = self.randomString(4); //  4位随机字符串
      let extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
      let fileName = "imgs/" + date + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）

      self.createOssClient().then(client => {
        client
          .put(fileName, file)
          .then(res => {
            if (res.res.statusCode === 200) {
              option.onSuccess(res);
              resolve({
                fileName: file.name,
                fileUrl: fileName
              });
            } else {
              option.onError("上传失败");
            }
          })
          .catch(e => {
            option.onError("上传失败");
            reject(e);
          });
      });
    });
  },
  /**
   * 文件上传 大文件 分片上传
   * @param option
   */
  ossUploadFile(option) {
    let file = option.file;
    const self = this;
    return new Promise((resolve, reject) => {
      let date = dateFormat(new Date(), "yyyyMMdd"); // 当前时间
      let randomStr = self.randomString(4); //  4位随机字符串
      let extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
      let fileName = "train-video/" + date + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
      // 执行上传
      self.createOssClient().then(client => {
        // 分片上传文件
        client
          .multipartUpload(fileName, file, {
            progress: function(p) {
              let e = {};
              e.percent = Math.floor(p * 100);

              option.onProgress(e);
            },
            meta: { year: 2020, people: "test" }
          })
          .then(
            val => {
              if (val.res.statusCode === 200) {
                option.onSuccess(val);
                resolve({
                  fileName: file.name,
                  fileUrl: fileName
                });
              } else {
                option.onError("上传失败");
              }
            },
            err => {
              option.onError("上传失败");
              reject(err);
            }
          );
      });
    });
  }
};
